export default __webpack_public_path__ + "static/media/quotes_group.c3decf3e.svg";